var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { faCircleQuestion } from "@fortawesome/pro-regular-svg-icons/faCircleQuestion";
import { faClose } from "@fortawesome/pro-regular-svg-icons/faClose";
import { faInfoCircle } from "@fortawesome/pro-regular-svg-icons/faInfoCircle";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box, IconButton, styled, Tooltip, Typography, SvgIcon, iconButtonClasses } from "@mui/material";
import { Label } from "../Label";
export const truffleModalTitleDragHandleClassName = "truffle-modal-title-drag-handle";
export const TruffleModalTitle = (_a) => {
    var { startIcon, children, InformationTooltipProps, LabelProps, headerAction, HelpCenterIconButtonProps, CloseIconButtonProps } = _a, boxProps = __rest(_a, ["startIcon", "children", "InformationTooltipProps", "LabelProps", "headerAction", "HelpCenterIconButtonProps", "CloseIconButtonProps"]);
    return (_jsxs(Wrapper, Object.assign({ className: truffleModalTitleDragHandleClassName }, boxProps, { children: [startIcon, typeof children === "string"
                ? _jsx(Typography, { variant: "subtitle1", color: "text.primary", children: children })
                : children, InformationTooltipProps && (_jsx(Tooltip, Object.assign({}, InformationTooltipProps, { children: _jsx(SvgIcon, { sx: { width: "12px", height: "12px", fontSize: "12px" }, color: "action", children: _jsx(FontAwesomeIcon, { icon: faInfoCircle }) }) }))), LabelProps && _jsx(Label, Object.assign({}, LabelProps)), (headerAction
                || HelpCenterIconButtonProps
                || CloseIconButtonProps) && (_jsxs(Actions, { children: [headerAction, HelpCenterIconButtonProps && (_jsx(IconButton, Object.assign({}, HelpCenterIconButtonProps, { children: _jsx(FontAwesomeIcon, { icon: faCircleQuestion }) }))), CloseIconButtonProps && (_jsx(IconButton, Object.assign({}, CloseIconButtonProps, { children: _jsx(FontAwesomeIcon, { icon: faClose }) })))] }))] })));
};
const Wrapper = styled(Box)({
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: "4px",
    paddingBlockEnd: "8px",
    position: "relative",
    [`& .${iconButtonClasses.root}:last-child`]: {
        marginInlineEnd: "-8px"
    },
    cursor: "grab"
});
const Actions = styled(Box)({
    marginInlineStart: "auto"
});
//# sourceMappingURL=TruffleModalTitle.js.map